import React from "react";
import "../../../../assets/styles/special_event.scss";
import "../../../../assets/styles/present_event.scss";
import { StaticImage } from "gatsby-plugin-image";
import Heartintune from "../../../../components/special-event/Heartintune";
import Layout from "../../../../layout";
import Seo from "../../../../components/seo";

// const getMandatoryEnv = require("sites-common/utils/getMandatoryEnv");

const PresentEvent = () => {
  return (
    <>
      <Seo
        title="Divya Janani - Registration"
        keyword="Divya Janani - Registration"
        description="Divya Janani - Registration"
      />
      <Layout isSticky wrapperClass="special_event divya-janani-banner-wr">
        <div>
          <div className="banner_wrapper bandara_banner_style position-relative">
            <StaticImage
              src="../../../../../static/divyajanani-bg.jpg"
              alt="Meditation event at World's largest meditation center"
              placeholder="blurred"
              className="dynamic-image"
            />
            <div className="main-img-wr">
              <StaticImage
                src="../../../../../static/DJ-Main.png"
                alt="Meditation event at World's largest meditation center"
                placeholder="blurred"
                className="dynamic-image"
              />
            </div>
            <div className="sub-img-wr">
              <StaticImage
                src="../../../../../static/the-way-of-love- black.png"
                alt="Meditation event at World's largest meditation center"
                placeholder="blurred"
                className="dynamic-image"
              />
              <h1>Divya Janani</h1>
              <p>Heartfulness Fertility Enablement Program</p>
            </div>
          </div>
          <section className="container py-4 my-4 divyajanani-event">
            <div className="row">
              <div className="col-12">
                <h3>Divya Janani: Fertility Enablement Program</h3>
              </div>
            </div>
            <div className="row">
              <div className="col-12 mt-4">
                <p>
                  It is offered by Heartfulness Wellness for couples who are
                  aspiring for parenthood. Divya Janani means &quot;Divine
                  Motherhood.&quot; It involves combining heart-based meditation
                  practices with science to address infertility.
                </p>
                <p>
                  Heartfulness practices when coupled with physical exercises,
                  effective communication that will lead to a deeper
                  understanding of relationships. This can bring about wonderful
                  results not only in terms of conception but also in terms of a
                  positive, peaceful, and balanced life between the couples.
                </p>
                <p>
                  We develop a positive, loving, and accepting environment, by
                  relieving stress and negativity and creating coherence and
                  acceptance. The couple who completes the program generally
                  experiences an improved sense of emotional well-being along
                  with enhanced fertility outcomes. Previous workshops have had
                  a success rate of 44% until 2021.
                </p>
                <p>
                  <strong>OBJECTIVES:</strong>
                </p>
                <ul>
                  <li>Enhance the possibility of conception.</li>
                  <li>Deepen the relationship between couples.</li>
                  <li>
                    Understand the physical, psychological, spiritual & social
                    dimensions of infertility.
                  </li>
                  <li>Empower couples to reduce isolation and self-blame.</li>
                </ul>
                <p>
                  <strong>WHO CAN ATTEND?</strong>
                </p>
                <ul>
                  <li>
                    Couples who wish to become parents but are unable to
                    conceive for 1-2 years.
                  </li>
                  <li>
                    The workshop is for couples as two people are involved in
                    the journey of parenthood. We request both partners to
                    attend.
                  </li>
                  <li>
                    The workshop can accommodate up to 15 couples. Registrations
                    are on a first-come-first-serve basis.
                  </li>
                </ul>
                <p>
                  <strong>PROGRAM DETAILS:</strong>
                </p>
                <ol>
                  <li style={{ marginBottom: "8px" }}>
                    It is a dynamic and interactive program filled with
                    activities, self-reflection, and group discussions. Sessions
                    will be facilitated by a multidisciplinary team of experts.
                  </li>
                  <li style={{ marginBottom: "8px" }}>
                    Sessions cover detox techniques, Heartfulness practices,
                    visualization, fitness, counseling, and other
                    self-reflective tools.
                  </li>
                  <li style={{ marginBottom: "8px" }}>
                    It is a 12-week online program starting from March 18, 2023,
                    to June 3, 2023. (Every Saturday, 6:00 PM - 7:30 PM IST ).
                    In addition to the online program, we shall have 3 days
                    onsite in Kanha Shanti Vanam. (25th May to 28th May 2023).
                  </li>
                  <li style={{ marginBottom: "8px" }}>
                    All the sessions will be in English only.
                  </li>
                </ol>
                <p>
                  <strong>Important Note:</strong> We mandate the couple (both
                  partners) to attend the sessions. The total fee for both
                  husband and wife together is 20,000 INR. Kindly do not
                  register separately.
                </p>
                {/* <p>
                  <Checkbox
                    checked={checked}
                    onChange={handleChange}
                    label="I hereby acknowledge that I have read and understood
                    the information above."
                    sx={{ display: "inline-block" }}
                  />
                </p> */}
              </div>
            </div>
            {/* <div className="row">
              <div className="col-12">
                <div className="mb-4 pb-2">
                  <PrimaryButton
                    disabled={!checked}
                    onClick={() => setOpenModal(true)}
                    text="Notify me when registration opens"
                  />
                </div>
              </div>
            </div> */}
          </section>
          <Heartintune />
        </div>
      </Layout>
    </>
  );
};

export default PresentEvent;
